import React from 'react';
import CmsPage from 'components/cms/cmsPage';

export default function CmsContainer() {
    return (
        <React.Fragment>
            {/* <Sidebar page={RODEO_PAGE_NAME.CMS} /> */}
            <section className="main-container">
                <CmsPage />
            </section>
        </React.Fragment>
    )
}